import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { baseURL } from "../../../config/api";
import Cookies from "js-cookie";

export const EditGroupType = () => {
    const navigate = useNavigate();
    const idNumber = useLocation();
    const token = Cookies.get("token-velox-charter");

    const [name, setName] = useState<string>("");
    const [description, setDescription] =
        useState<string>("");
    const [enabled, setEnabled] =
        useState<string>("Yes");

    const [groupTypeData, setGroupTypeData] =
        useState<any>(null);

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    useEffect(() => {
        setPleaseWaitPopup(true);

        axios
            .get(
                `${baseURL}group-types/${idNumber?.state}`
            )
            .then((response) => {
                const groupType =
                    response?.data?.data;

                setGroupTypeData(groupType);

                setName(
                    groupType?.name ?? ""
                );

                setDescription(
                    groupType?.description ?? ""
                );

                setEnabled(
                    groupType?.isActive
                        ? "Yes"
                        : "No"
                );

                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error fetching group type:",
                    error
                );
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber]);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            ...groupTypeData,

            name: name.trim(),
            description: description.trim(),
            isActive: enabled === "Yes"
        };

        await axios
            .put(
                `${baseURL}group-types/${idNumber?.state}`,
                payload,
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: false
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error updating group type:",
                    error
                );
            });
    };


    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Edit Group Type
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={name}
                                            placeholder="Group Type Name"
                                            onChange={(e) =>
                                                setName(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Active
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                </div>


                                <div className="grid grid-cols-1 gap-6 mb-4">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">
                                            Description
                                        </label>

                                        <textarea
                                            rows={4}
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Group Type Description"
                                            className="w-full p-4 border border-gray-300 rounded-md bg-white resize-none outline-none focus:border-primary"
                                        />
                                    </div>

                                </div>


                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>


                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate(-1)
                                        }
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};